import { Component, forwardRef, Input } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";

import { FieldCoreComponent } from "../FieldCoreComponent";
import { OptionConfigAdapter } from "../OptionConfigAdapter";
import { MedLabelModeType, MedOptionType } from "../types";
import { OptionTypeLocal } from "../types.local";
import { STRING } from "../../../constants/string";
import { simpleCompare } from "../../../utils/base.util";
import { NgClassType } from "../../../types";

export type MedRadioMode = "" | "buttons";
export type MedRadioPosition = "" | "horizontal";

@Component({
  selector: "med-radio-group",
  templateUrl: "./med-radio-group.component.html",
  styleUrls: ["./med-radio-group.component.scss"],
  providers: [{
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MedRadioGroupComponent),
  }],
})
export class MedRadioGroupComponent<ValueType> extends FieldCoreComponent<ValueType> {
  private _options: OptionTypeLocal<ValueType>[] = [];

  @Input() mode: MedRadioMode = "";
  @Input() position: MedRadioPosition = "";

  get options(): OptionTypeLocal<ValueType>[] {
    return this._options;
  }

  get groupClassList(): NgClassType {
    return {
      buttons: this.mode,
      horizontal: this.position,
    };
  }

  get labelMode(): MedLabelModeType {
    return this.mode === STRING.EMPTY ? "column" : "horizontal";
  }

  @Input() set options(list: MedOptionType<ValueType>[]) {
    this._options = list.map(el => new OptionConfigAdapter(el));
  }

  compare(optionValue: ValueType): boolean {
    return simpleCompare(optionValue, this.value);
  }
}
